var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar__search"},[_c('GmapAutocomplete',{staticClass:"search-input form__input",attrs:{"placeholder":_vm.strings.searchby},on:{"place_changed":_vm.gotoSearch}}),_c('img',{staticClass:"search-input__icon",attrs:{"src":require("../assets/img/icon-search.svg"),"alt":"Venue Search Icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }